import PropTypes from 'prop-types';
import * as S from './styles';

export default function GenericTable({ items, columns, fixed }) {
  const hasWidths = columns.some((col) => col.width);

  return (
    <S.TableWrapper>
      <S.Table $fixed={fixed}>
        {hasWidths && (
          <colgroup>
            {columns.map((col, i) => (
              <col key={`${String(i)}`} style={col.width ? { width: col.width } : undefined} />
            ))}
          </colgroup>
        )}
        <thead>
          <tr>
            {columns.map((col, i) => (
              <S.TableHeader key={`${String(i)}`} $align={col.align}>{col.label}</S.TableHeader>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={`${String(index)}`}>
              {columns.map((col, i) => {
                return col.component
                  ? col.component(item[col.name], i, item)
                  : <S.Cell key={`${String(i)}`}>{item[col.name]}</S.Cell>;
              })}
            </tr>
          ))}
        </tbody>
      </S.Table>
    </S.TableWrapper>
  );
}

GenericTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  fixed: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    component: PropTypes.func,
    align: PropTypes.oneOf(['left', 'right', 'center']),
    width: PropTypes.string,
  })).isRequired,
};

GenericTable.defaultProps = {
  fixed: false,
};
